import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { languageOptions } from "./entries";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.keys(languageOptions),
    fallbackLng: "en",
    debug: false,
    detection: {
      caches: [],
    },
    ns: ["common", "dashboard", "edit", "errors", "settings", "sidebar"],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_I18N_VERSION || "1.1"}`,
    },
  });

export default i18n;
